/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_ObjectivesInputs */



/**
* | output |
* | --- |
* | "What you practised" |
*
* @param {Practice_Feedback_ObjectivesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_objectives = /** @type {((inputs?: Practice_Feedback_ObjectivesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_ObjectivesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Waar je op oefende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que vous avez travaillé")
	return /** @type {LocalizedString} */ ("What you practised")
});